var _Confirmation, _div;
import PropTypes from 'prop-types';
import React from 'react';
import { Alert, Button } from 'reaxl';
import { Form, StandardEmailInput, Input, validationRules } from 'reaxl-forms';
import Confirmation from '../Confirmation/index.js';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const renderError = serverError => /*#__PURE__*/_jsx(Alert, {
  bsStyle: "danger",
  children: serverError
});
const validationMessages = {
  hasInvalidChars: 'contains invalid characters.',
  isProfane: 'Please remove all profanity from your message.',
  enterFirst: 'Enter your first name.',
  enterRecipientEmail: "Enter recipient's email address"
};

/**
 *  This component allows you to send emails to others
 *
 */
const ShareEmail = /*#__PURE__*/React.memo(_ref => {
  let {
    firstName = '',
    lastName = '',
    email: senderEmail = '',
    shareLink,
    listingId,
    ownerId,
    onSubmit = () => {},
    serverError,
    showConfirmation,
    resetEmailFriend = () => {},
    ip,
    originPage,
    searchZip,
    partnerName,
    lnxCode,
    cookieId,
    myAtcUserLoggedIn,
    ...rest
  } = _ref;
  validationRules();
  if (showConfirmation) {
    return _Confirmation || (_Confirmation = /*#__PURE__*/_jsx(Confirmation, {
      text: "Your Email has been sent.",
      confirmationMessage: ""
    }));
  }
  const emailFriendSubmit = formData => {
    const requestData = {
      shareLink,
      listingId,
      ownerId,
      ip,
      originPage,
      searchZip,
      partnerName,
      lnxCode,
      cookieId,
      myAtcUserLoggedIn,
      ...formData
    };
    onSubmit(requestData);
    resetEmailFriend();
  };
  return /*#__PURE__*/_jsx("div", {
    ...rest,
    children: /*#__PURE__*/_jsxs(Form, {
      onValidSubmit: emailFriendSubmit,
      children: [serverError && renderError(serverError), /*#__PURE__*/_jsxs("div", {
        className: "row",
        children: [/*#__PURE__*/_jsx("div", {
          className: "col-xs-12 col-sm-6",
          children: /*#__PURE__*/_jsx(Input, {
            label: "Your First Name",
            name: "firstName",
            required: true,
            validations: {
              isValidName: true,
              isNotProfane: true
            },
            validationErrors: {
              isValidName: `First Name ${validationMessages.hasInvalidChars}`,
              isNotProfane: validationMessages.isProfane,
              isDefaultRequiredValue: validationMessages.enterFirst
            },
            value: firstName
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "col-xs-12 col-sm-6",
          children: /*#__PURE__*/_jsx(Input, {
            label: "Your Last Name",
            name: "lastName",
            optional: true,
            validations: {
              isValidName: true,
              isNotProfane: true
            },
            validationErrors: {
              isValidName: `Last Name ${validationMessages.hasInvalidChars}`,
              isNotProfane: validationMessages.isProfane
            },
            value: lastName
          })
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "row",
        children: [/*#__PURE__*/_jsx("div", {
          className: "col-xs-12 col-sm-6",
          children: /*#__PURE__*/_jsx(StandardEmailInput, {
            label: "Your Email",
            name: "from",
            required: true,
            value: senderEmail
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "col-xs-12 col-sm-6",
          children: /*#__PURE__*/_jsx(StandardEmailInput, {
            label: "Recipient's Email",
            name: "to",
            required: true,
            validationErrors: {
              isDefaultRequiredValue: validationMessages.enterRecipientEmail
            }
          })
        })]
      }), _div || (_div = /*#__PURE__*/_jsx("div", {
        className: "display-flex justify-content-center",
        children: /*#__PURE__*/_jsx(Button, {
          type: "submit",
          bsStyle: "primary",
          className: "col-xs-12 col-sm-4",
          formNoValidate: true,
          children: "Send Email"
        })
      }))]
    })
  });
});
export default ShareEmail;